import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';

function useTranslationCommon(keyPrefix?: string): TFunction {
  const { t } = useTranslation('common', { keyPrefix });
  return t;
}

export default useTranslationCommon;
